module.exports = __webpack_public_path__ + "media/images/vp/tutorialpopup.4-de8d14b25533b5921cc2454769b0ed12.svg";